/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Home_Board_Today_TitleInputs */

const en_directory_home_board_today_title = /** @type {(inputs: Directory_Home_Board_Today_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launched in the last 24 hours`)
};

const zh_directory_home_board_today_title = /** @type {(inputs: Directory_Home_Board_Today_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最近 24 小时发布`)
};

/**
* | output |
* | --- |
* | "Launched in the last 24 hours" |
*
* @param {Directory_Home_Board_Today_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_home_board_today_title = /** @type {((inputs?: Directory_Home_Board_Today_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Home_Board_Today_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_home_board_today_title(inputs)
	return zh_directory_home_board_today_title(inputs)
});
export { directory_home_board_today_title as "directory.home.board.today_title" }